import GetBaseURLPlacementAPI from "Placements/Utils/GetBaseURLPlacementAPI.util"

const GetStaticImgUrl = (url: string) => `${GetBaseURLPlacementAPI()}/assets/img/img_exercicios/${url}`

export default GetStaticImgUrl
